import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

function createPatch(entry, key, value) {
  const patch = { recordInfo: { ...entry.recordInfo } };
  patch.recordInfo[key] = value;
  return patch;
}

async function patchData(
  module,
  categoryID,
  entry,
  entryPath,
  entryIndex,
  key,
  value,
  opts
) {
  const { dispatch } = module;
  const patch = createPatch(entry, key, value);
  const config = Object.assign(opts, {
    isCms: true,
  });
  await dispatch("patchEntry", {
    categoryID,
    path: entryPath,
    patch,
    opts: config,
  });
}

async function updateStore(module, categoryID, entry, entryIndex, key, value) {
  const { getters, commit } = module;
  const category = { ...getters.category(categoryID) };
  const patch = createPatch(entry, key, value);
  category.entries[entryIndex] = Object.assign(entry, patch);
  commit("storeCategory", category);
}

const patchEntryRecord = async (
  module,
  { categoryID, entryPath, key, value, opts = {} }
) => {
  const { getters } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  const category = { ...getters.category(categoryID) };
  const entryIndex = category.entries.findIndex(
    (entry) => entry.path === entryPath
  );
  if (entryIndex === -1) {
    console.error("Entry not found!");
  }
  const entry = category.entries[entryIndex];
  await patchData(
    module,
    categoryID,
    entry,
    entryPath,
    entryIndex,
    key,
    value,
    config
  );
  await updateStore(module, categoryID, entry, entryIndex, key, value);
};

export { patchEntryRecord };
